import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { getToken } from '../../utils/sessionManagement'
import { Form_createForm } from '../../services/api'

function CreateForm() {
  const navigate = useNavigate()
  const flag = useRef(false)

  useEffect(() => {
    if (flag.current === false) {
      const fetchData = async () => {
        try {
          const formData = {
            title: 'Formulaire sans titre', // Titre du formulaire à envoyer à l'API
          }
          const response = await Form_createForm(formData)
          const { url_code } = response

          navigate(`/sandbox/${url_code}`)
        } catch (error) {
          console.error('Erreur lors de la création du formulaire :', error)
        }
      }

      if (getToken()) {
        fetchData()
      }
    }

    return () => (flag.current = true)
  }, [navigate])

  return (
    <div>
      <h1>Création de formulaire...</h1>
    </div>
  )
}

export default CreateForm
